<template>
  <div id="services">
    <div class="title">
      <h1>Top Brands</h1>
    </div>
    <ul class="ws" style="min-height:750px;">
      <li class="l" v-for="(data,index) in goodsbrands" :key="index">
        <img :src="data.brandImg" alt @click="handleclick(data.key)" />
      </li>
    </ul>
<!-- v-show="$store.state.isshowPdf" -->
    <div class="header" id="pdfDom" v-show="false">
      <div class="logo l pdf">
        <img src="../../public/img/Icon6.png" alt />
      </div>
      <div class="center l pdf">
        <h1>TAX INVOICE</h1>
      </div>
      <div class="address l pdf">
        <p>ABN：46 612 389 143</p>
        <p>Address：2/489Nicholson Rd,Canningvale WA 6155</p>
        <p>PH：(08)6113 6617</p>
        <p>
          <a href="#">admin@awesomewarehouse.com.cn</a>
        </p>
        <p>
          <a href="#">https://www.awesomewholesale.com.au</a>
        </p>
      </div>
      <div class="both" style="clear:both;"></div>
      <div class="invoice l pdf">Invoice No:23120441703215</div>
      <div class="invoice l pdf">Invoice Data:23 Dec 2020</div>
      <div class="invoice l pdf">
        <p>Invoice to:</p>
        <p>李先生</p>
      </div>
      <div class="invoice l pdf">
        <p>Delivery Address:</p>
        <p>辽宁 沈阳</p>
      </div>
      <div class="both" style="clear:both;"></div>
      <p class="sales" style="height: 60px; margin-left:280px;">Sales Rep:无情</p>
      <ul class="product">
        <li class="products" style="border-bottom:2px solid black; font-weight:600;">
          <span class="num1">Product Description</span>
          <span class="num2">Product Code </span>
          <span class="num3">Number</span>
          <span class="num4">price</span>
          <span class="num5">Disc</span>
          <span class="num6">W/sale</span>
           <span class="num7">Gst</span>
            <span class="num8">Totol</span>
        </li>

        <li class="products" style="border-bottom:2px solid #ccc;" v-for="(data,index) in goodsbrandss" :key="index">
          <span class="num1">大宝SOD蛋白霜</span>
          <span class="num2">524 52145 25</span>
          <span class="num3">100</span>
          <span class="num4">$11.45</span>
          <span class="num5">80%</span>
           <span class="num6">$7.62</span>
            <span class="num7">$0.00</span>
             <span class="num8">$762</span>
        </li>

        <li
          class="products"
          style="text-align:right;line-height: 40px;  font-weight:600; padding-right:50px;"
        >Total price: $100</li>
      </ul>
      <div class="news">
        <p>Bank Account Details:</p>
        <p>GNG International Trading Pty Ltd</p>
        <p>Commonwealth</p>
        <p>BSB:066-134</p>
        <p>ACCOUNT:1098 3881</p>
      </div>
      <!-- <div class="both" style="clear:both;"></div> -->
    </div>
    <button @click="getPdf(htmlTitle)" v-show="false">导出PDF</button>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      htmlTitle: '澳盛批发订单',
      // nowTime: ""
      goodsbrandss: [1, 2, 3, 45, 5, 4, 5, 4, 4, 5, 45, 4, 54, 4, 848, 4, 8, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      goodsbrands: []
    }
  },
  methods: {
    handleclick (id) {
      this.$store.state.brandsId = true
      this.$router.push('/goodlist')
      sessionStorage.setItem('brandsId', id)
      sessionStorage.setItem('goodsCode', 1)
      sessionStorage.removeItem('typeId')
      this.$store.dispatch('getGoodslistAction', {
        goodsBrands: sessionStorage.getItem('brandsId')
      })
    }
  },
  mounted () {
    this.$store.state.value = ''
    sessionStorage.removeItem('goodsName')
    axios.get(`${this.APi}/api/v1/wholesale/goodsBrands`, {}).then(res => {
      this.goodsbrands = res.data.result
    })
  }
  // beforeRouteEnter(to, from, next) {
  //   console.log(to.path,sessionStorage.getItem('goodsName'));
  //   sessionStorage.removeItem('goodsName')
  //    next();
  // }
}
</script>

<style lang="scss">
#services {
  .title {
    h1 {
      text-align: center;
      font-size: 0.625rem;
      color: #223457;
    }
  }
  ul {
    // width:100%;
    overflow: hidden;
    li {
      width: 19%;
      margin: 3%;
      img {
        width: 100%;
        height: 1.25rem;
        cursor: pointer;
      }
    }
  }
  .header {
    transform: scale(0.7, 0.7);
    .pdf {
      width: 6.325rem;
    }
    .logo {
      img {
        width: 3.25rem;
      }
    }
    .center {
      h1 {
        text-align: center;
        box-sizing: border-box;
        padding-top: 1.825rem;
        font-size: 0.625rem;
      }
    }
    .address {
      box-sizing: border-box;
      padding-left: 1.537rem;
      padding-top: 0.4375rem;
      p {
        margin-bottom: 0;
      }
    }
    .invoice {
      // display: none;
      height: 1.25rem;
      width: 50%;
      line-height: 1.25rem;
      text-align: center;
      font-weight: 600;
      p {
        line-height: 0.375rem;
        margin-bottom: 0;
      }
    }
    .product {
      // display: none;
      .products {
        width: 100%;
        margin: 0;
        span {
          display: inline-block;
          width: 9.8%;
          text-align: center;
          line-height: 0.6rem;
        }
        span.num1 {
          text-align: left;
          width: 31%;
        }
      }
    }
    .news {
      // display: none;
      p {
        margin-bottom: 0;
      }
    }
  }
}
</style>
